import React from 'react'
import { Link } from 'react-router-dom'
import styles from './MenuMobile.module.scss'
import logo from '../../image/Header/logo.png'

export const MenuMobile = ({onClose}) => {

    return (
        <div className={styles.main}>
            <div className={styles.box}>
                <img className={styles.logo} src={logo} alt = 'логотип'/>
                <button className={styles.button} onClick={onClose} aria-label='закрыть меню'/>
            </div>
            <nav className={styles.nav}>
                    <a className={styles.link} href='#Services' onClick={onClose}>Наши услуги</a>
                    <Link className={styles.link} to="/produkciya" onClick={onClose}>Продукция</Link>
                    <a className={styles.link} href='#Advantages' onClick={onClose}>Преимущества</a>
                    <a className={styles.link} href='#Portfolio' onClick={onClose}>Портфолио</a>
                    <a className={styles.link} href='#Deadlines' onClick={onClose}>Как заказать</a>
                    <a className={styles.link} href='#Kontakty' onClick={onClose}>Контакты</a>
            </nav>
        </div>
    );
}
